import { useEffect, useState } from "react"
import API from "../../../services/API"
import Files from "../../Inputs/Files"

export default function CourseDocs({id}){

    const [docs, setDocs] = useState(null)

    const [loading, setLoading] = useState(false)

    useEffect(() => {

        API.get(`/docs?type=course&code=${id}`)
            .then(r => setDocs(r.data))

    }, [id])

    
    const handleAdd = files => {

        setLoading(true)

        saveDocs(files, id)
            .then(newDocs => setDocs(newDocs.concat([...docs])))
            .catch(newDocs => setDocs(newDocs.concat([...docs])))
            .finally(() => setLoading(false))
    }


    const handleDelete = file => {

        const old = [...docs];

        setDocs([...docs].filter(d => d.name !== file.name))

        API.delete(`/docs/${file.id}`)
            .then(r => console.log(r.data))
            .catch(_ => setDocs(old))

    }

    return docs && <Files
        id='course-docs'
        label="Ajouter des documents PDF"
        value={docs}
        onAdd={handleAdd}
        onDelete={handleDelete}
        accept={['application/pdf']}
        loading={loading}
    />
}


const saveDocs = async (files, courseId) => {

    let newDocs = [];

    for(let i = 0; i < files.length; i++){

        let file = files[i]

        let formData = new FormData()
        formData.append('file', file)
        formData.append('type', 'course')
        formData.append('code', courseId)
        formData.append('name', file.name)

        try{
            let response = await API.post(`/docs`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
                
            newDocs.push(response.data)

        }catch(e){
            console.error(e)

            return newDocs
        }
    }

    return newDocs;
}